export default __webpack_public_path__ + "static/palette-saturated-mapping-6f513340b8b2d7e72934eaf42b84b0c6.png";